import { createFileRoute } from "@tanstack/react-router";
import { ForecastingBookPage } from "./forecasting.contracts";

export const Route = createFileRoute("/forecasting/profile-builder")({
  component: ForecastProfileBuilderRoute,
});

function ForecastProfileBuilderRoute() {
  return <ForecastingBookPage view="profiles" />;
}
